import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { PhoneInput } from '@bambi/component-library/src/components/inputs/PhoneInput';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';
import { useFormContext } from 'react-hook-form';

import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { useUserRoles } from 'src/features/auth/useUserRoles';

import { GlobalPayerSelect } from './fields/GlobalPayerSelect';
import PayerActiveToggleField from './PayerActiveToggleField';

export const PayerBasicInformation = () => {
  const { getValues, setValue } = useFormContext();
  const { isBambi } = useUserRoles();

  const payerTypeOptions = [
    { label: 'Broker', value: 'broker' },
    { label: 'Insurance', value: 'insurance' },
    { label: 'Private/Invoice', value: 'private' },
  ];
  return (
    <>
      <div className="flex flex-col gap-3 py-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div>
            <FormFieldController
              name="display_name"
              rules={{ required: 'Display name is required' }}
            >
              {({ field, fieldState }) => {
                return (
                  <FormField
                    label="Display Name*"
                    error={fieldState.error?.message?.toString()}
                    type="text"
                    inputProps={{
                      id: 'display_name',
                      ...field,
                      'data-testid': 'display_name',
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
          </div>
          <div>
            <FormFieldController name="alternate_name">
              {({ field, fieldState }) => {
                return (
                  <FormField
                    label="Billing Display Name"
                    error={fieldState.error?.message?.toString()}
                    type="text"
                    inputProps={{
                      id: 'alternate_name',
                      ...field,
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
          </div>
          <div>
            <PayerActiveToggleField />
          </div>
        </div>

        <h2 className=" text-xl">Basic Information</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div>
            <FormFieldController name="type">
              {({ field, fieldState }) => {
                return (
                  <DefaultFormFieldLayout
                    label="Payer Type"
                    error={fieldState.error?.message?.toString()}
                    inputId="payer_type"
                  >
                    <Select
                      value={field.value}
                      options={payerTypeOptions}
                      onChange={(selected) => {
                        field.onChange(selected?.value);

                        const id = getValues('id');
                        const isBroker = selected?.value === 'broker';

                        // only update if user is not editing an existing payer
                        if (!id) {
                          setValue('can_multiload', isBroker);
                        }
                      }}
                    />
                  </DefaultFormFieldLayout>
                );
              }}
            </FormFieldController>
          </div>
          <div>
            <FormFieldController
              name="website"
              rules={{
                validate: (value) => {
                  if (value) {
                    try {
                      new URL(value);
                      return true;
                    } catch {
                      return 'Invalid URL';
                    }
                  }
                  return true;
                },
              }}
            >
              {({ field, fieldState }) => {
                return (
                  <FormField
                    label="Website"
                    error={fieldState.error?.message?.toString()}
                    type="text"
                    inputProps={{
                      id: 'website',
                      ...field,
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
          </div>
          <div>
            <FormFieldController name={'phone_number'}>
              {({ field }) => {
                return (
                  <div>
                    <DefaultFormFieldLayout
                      label="Phone Number"
                      inputId="phone_number"
                    >
                      <PhoneInput
                        {...field}
                        placeholder="(555) 555-5555"
                        dataTestId="phone"
                      />
                    </DefaultFormFieldLayout>
                  </div>
                );
              }}
            </FormFieldController>
          </div>

          <div>
            <FormFieldController name="email">
              {({ field, fieldState }) => {
                return (
                  <FormField
                    label="Email"
                    error={fieldState.error?.message?.toString()}
                    type="email"
                    inputProps={{
                      id: 'email',
                      ...field,
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
          </div>
          <div>
            <FormFieldController name="ein">
              {({ field, fieldState }) => {
                return (
                  <FormField
                    label="EIN"
                    error={fieldState.error?.message?.toString()}
                    type="text"
                    inputProps={{
                      id: 'ein',
                      ...field,
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
          </div>
          <div>
            <FormFieldController name="external_id">
              {({ field, fieldState }) => {
                return (
                  <FormField
                    label="External Id"
                    error={fieldState.error?.message?.toString()}
                    type="text"
                    inputProps={{
                      id: 'external_id',
                      ...field,
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
          </div>

          {isBambi ? (
            <div>
              <FormFieldController name="payer">
                {({ field, fieldState }) => {
                  return (
                    <GlobalPayerSelect
                      onChange={field.onChange}
                      value={field.value}
                      error={fieldState.error?.message?.toString()}
                    />
                  );
                }}
              </FormFieldController>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};
